import { program } from "../positionWrapper";

program.parse(process.argv);
